export default __webpack_public_path__ + "static/media/alien12.94d40677.png";